import BasicLayout from '@/apps/assessment/components/basic-layout/index.vue'
import QuestionCenter from '@/apps/assessment/components/QuestionCenter.vue'
import ScrollToTop from '@/apps/index/mixins/scrollToTop'
import { getInitInfo } from '@/apps/index/models/api'
import CommonTab from '@/apps/mistake/components/CommonTab.vue'
import { getConfirmBooks, questionList } from '@/apps/mistake/model/api'
import LabelContainer from '@/apps/question/components/LabelContainer.vue'
import LeftMenu from '@/apps/question/components/LeftMenu.vue'
import PreviewBtn from '@/apps/question/components/PreviewBtn.vue'
import QPending from '@/apps/question/components/question-pending'
import QuestionBox from '@/apps/question/components/QuestionBox.vue'
import AssessmentTrackMixin from '../mixins/assessment-track-mixin'
import RouterMixin from '../mixins/router-mixin'

import {
  addQuestionToCart,
  removeUestionFromCart,
  updateQuestionCart
} from '@/apps/question/model/api'
import { NoResult } from '@/components'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import LessInfo from '@/components/LessInfo'
import axios from 'axios'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'

const usage = 3
const classTab = { name: '班级错题', value: '1' }
const gradeTab = { name: '年级错题', value: '2' }
const highTab = { name: '高频错题', value: '3' }
const timeList = [
  ['', '全部'],
  ['week', '近一周'],
  ['month', '近一月'],
  ['3month', '近三月'],
  ['6month', '近半年'],
  ['year', '近一年'],
  ['-year', '一年前']
]
const errorRate = [
  ['', '全部'],
  ['100%-75%', '100%-75%'],
  ['75%-50%', '75%-50%'],
  ['50%-25%', '50%-25%'],
  ['25%-0%', '低于25%']
]

@Component({
  components: {
    LeftMenu,
    BasicLayout,
    QuestionCenter,
    NoResult,
    QuestionBox,
    PreviewBtn,
    LabelContainer,
    CommonTab,
    LessInfo,
    QPending,
    SmallBtnSkeleton
  }
})
export default class MistakeAssessment extends Mixins(AssessmentTrackMixin, RouterMixin, ScrollToTop) {
  public get subjectId() {
    return this.$store.state.subject.value
  }
  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get book() {
    return this.$store.state.question.book
  }
  private get bookorkps() {
    return this.$store.state.question.bookorkps
  }
  private get singleormulti() {
    return this.$store.state.question.singleormulti
  }
  private get platformlogin() {
    return this.$store.state.platformlogin
  }
  private get kps() {
    return this.$store.state.question.kps || []
  }
  private get catalog() {
    return this.$store.state.question.catalog
  }
  private get factors() {
    return this.$store.state.question.factors
  }
  private get textbookVersion() {
    return this.$store.state.question.textbookVersion
  }
  private get grade() {
    return this.$store.state.question.grade
  }
  private get switchTemplate() {
    if (this.loading) {
      return 'pending'
    } else {
      if (this.questions && this.questions.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }
  private get moduleName() {
    return this.$route.meta.name
  }
  private get hideChapter() {
    return this.defaultTab && this.defaultTab.value !== '3'
  }
  private get isClazz() {
    return this.$route.meta.section === '班级测评'
  }
  private get qTypeChoices() {
    return this.cp_question_types && this.cp_question_types[this.questionClass[0]]
  }
  // 筛选项
  private defaultTab = { name: '班级错题', value: '1' }
  private qGradeChoices: any[] = [] // 年级选项
  private qClassChoices: any[] = [] // 班级选项
  private questionClassChoices: any[] = [] // 题目类型
  private cp_question_types: any = {}
  private questionClass: any = []
  private errrateChoices: any = errorRate
  private isUnion = '1'
  private qClass: any = {}
  private qGrade: any = {}
  private qType = [-1, '全部']
  private qErrRate = ['', '全部']
  private page = 1
  private total = 0
  private sortType = 0
  private currentTitle = ''
  private hasAnalysis = false
  private questions: any[] = []
  private sum = 0 // 用于分页显示最多显示100页的数据
  private perPage = 5 // 每页显示5道题
  private loading = false
  private unMounted = true
  private tabs = [classTab, gradeTab, highTab]
  private timeList = timeList
  private selectedTime = ['', '全部']
  private visible = false
  private optionsLoading = true
  private form = {
    start: 1,
    end: 0
  }
  private rules = {
    start: [
      {
        required: true,
        validator: this.checkStart,
        trigger: ['change', 'blur']
      }
    ],
    end: [{ required: true, validator: this.checkEnd, trigger: ['change', 'blur'] }]
  }
  private gradeLevels: any[] = []
  private gradeLevel = []
  private QuestionApiSource: any = null

  public checkStart(rule, value, callback) {
    if (!value) {
      callback('不能为空')
    } else {
      if (Number(value) <= Number(this.form.end)) {
        callback('大数在前')
      } else {
        callback()
      }
    }
  }
  public checkEnd(rule, value, callback) {
    if (!value) {
      if (value == 0) {
        callback()
      } else {
        callback('不能为空')
      }
    } else {
      if (Number(value) >= Number(this.form.start)) {
        callback('大数在前')
      } else {
        callback()
      }
    }
  }
  public mounted() {
    window.addEventListener('message', (event) => {})
    this.getFilterList(true)
  }
  public async getUsableBooks() {
    let data = await getConfirmBooks({ subject: 'CHINESE', level: 1, term: 1 })
  }

  @Watch('subjectId')
  public onSubjectChange(val, old) {
    if (val === old) return
    this.qType = [-1, '全部']
    this.qClass = {}
    this.qGrade = {}
    this.currentTitle = ''
    this.hasAnalysis = false
    this.sortType = 0
    if (~~this.bookorkps === 2) {
      this.getFilterList(true)
    } else {
      this.getFilterList(false)
    }
  }
  @Watch('book')
  public onBookChange(val, old) {
    if (~~this.bookorkps === 2) return
    if (val === old) return
    if (!this.unMounted) {
      this.loadQuestions(this.page = 1)
    }
  }
  @Watch('bookorkps')
  public onBookorKpsChange(val, old) {
    if (val === old) return
    this.loadQuestions(this.page = 1)
  }
  @Watch('singleormulti')
  public onSingleormultiChange(val, old) {
    if (val === old) return
    this.loadQuestions(this.page = 1)
    console.log(8)
  }
  @Watch('kps')
  public onKpsChange(val) {
    if (~~this.bookorkps === 1) return
    this.loadQuestions(this.page = 1)
  }
  @Watch('catalog')
  public onCataChange(val) {
    console.log('cata')
    this.loadQuestions(this.page = 1)
  }
  @Watch('factors')
  public onFactorsChange(val) {
    if (~~this.bookorkps === 1) return
    this.loadQuestions(this.page = 1)
  }
  // 点击确定
  public onModalOk() {
    const ruleForm: any = this.$refs.ruleForm
    const rate = `${this.form.start}%-${this.form.end}%`
    ruleForm.validate((valid) => {
      if (valid) {
        this.errrateChoices = [...errorRate, [rate, rate]]
        this.qErrRate = [rate, rate]
        this.visible = false
        this.loadQuestions((this.page = 1))

        window['sensors'].track('TIKU_filter_clk', {
          moduleName: this.moduleName,
          filter: '错误率',
          value: rate,
          paper_type: ''
        })
      }
    })
  }
  // 弹窗容器
  public getContainer() {
    return document.getElementById('app')
  }
  // 打开弹窗
  public openModal() {
    this.visible = true
  }
  // 弹窗关闭
  public onModalCancel() {
    this.visible = false
  }
  // 选择班级错题/年级错题
  public onTabSelect(data): void {
    this.qType = [-1, '全部']
    this.qErrRate = ['', '全部']
    this.defaultTab = data
    if (this.defaultTab && this.defaultTab.value === '3') {
      this.currentTitle = ''
      if (this.bookorkps === '1') {
        this.loadQuestions(this.page = 1)
      }
    } else {
      this.loadQuestions(this.page = 1)
    }

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '错题分类',
      value: this.defaultTab.name,
      paper_type: ''
    })
  }
  public processFactors(val) {
    let temp: any = []
    if (val && val.length) {
      for (let n of val) {
        temp = [...temp, ~~n.split('?')[0]]
      }
    }
    return temp
  }
  public unionChange(val) {
    this.isUnion = val
  }
  // tslint:disable-next-line:cyclomatic-complexity
  public async getFilterList(loadquestions?) {
    try {
      const reg = /^2\d{2}$/ // 初中学科id
      this.optionsLoading = true
      let { data, success }: any = await getInitInfo({ subject_id: this.subjectId })
      if (success) {
        this.gradeLevels = data.grade_choices.filter((n) => {
          if (reg.test(this.subjectId)) {
            return n[0] != 0 && n[0] != 6
          } else {
            return n[0] != 0
          }
        })
        // 判断是否需要类型
        if (
          data.cp_question_types &&
          data.cp_question_types.all &&
          data.cp_question_types.all.length > 0
        ) {
          this.questionClassChoices = []
          this.questionClass = ['all', '']
        } else {
          this.questionClassChoices = [
            ['oral', '口语'],
            ['listen', '听力'],
            ['write', '笔试']
          ]
          this.questionClass = this.questionClassChoices[0]
        }
        Object.values(data.cp_question_types).forEach((item: any) => {
          item = item.unshift([-1, '全部'])
        })
        this.cp_question_types = data.cp_question_types

        this.gradeLevel = this.gradeLevels[0]
        // this.question_types = [[-1, '全部'], ...cp_question_types]
        this.qGradeChoices = data.err_class_grade_choice.grade
        this.qClassChoices = data.err_class_grade_choice.class
        this.qClass = data.err_class_grade_choice.class[0] || {} // 默认选中班级
        this.qGrade = data.err_class_grade_choice.grade[0] || {} // 默认选中年级
        if (
          this.qGradeChoices &&
          this.qGradeChoices.length > 0 &&
          this.qClassChoices &&
          this.qClassChoices.length > 0
        ) {
          this.tabs = [classTab, gradeTab, highTab]
          this.defaultTab = classTab
        } else if (
          this.qGradeChoices &&
          this.qGradeChoices.length > 0 &&
          this.qClassChoices &&
          this.qClassChoices.length === 0
        ) {
          this.tabs = [gradeTab, highTab]
          this.defaultTab = gradeTab
        } else if (
          this.qGradeChoices &&
          this.qGradeChoices.length === 0 &&
          this.qClassChoices &&
          this.qClassChoices.length > 0
        ) {
          this.tabs = [classTab, highTab]
          this.defaultTab = classTab
        } else {
          this.tabs = [highTab]
          this.defaultTab = highTab
        }
        if (data.default_book && data.default_book.length > 0) {
          this.$store.commit('SET_DEFAULTBOOK', data.default_book)
        }
        if (loadquestions) {
          this.unMounted = false
          this.$nextTick(() => {
            this.loadQuestions(this.page = 1)
          })
        }
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.optionsLoading = false
    }
  }
  public judgeSelected(itm, temp) {
    return itm[0] === temp[0]
  }
  public judgeClassSelected(itm, temp) {
    return itm.class_id === temp.class_id
  }
  public judgeGradeSelected(itm, temp) {
    return itm.level === temp.level
  }
  public clickQGrade(itm) {
    this.qGrade = itm
    this.loadQuestions(this.page = 1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '年级',
      value: itm.level_name,
      paper_type: ''
    })
  }
  public clickQClass(itm) {
    // console.log(itm)
    this.qClass = itm
    this.loadQuestions(this.page = 1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '班级',
      value: itm.full_class_name,
      paper_type: ''
    })
  }
  public clickQuestionClass(itm) {
    this.questionClass = itm
    this.qType = [-1, '全部']
    this.loadQuestions(this.page = 1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '类型',
      value: itm[1],
      paper_type: ''
    })
  }
  public clickQtype(itm) {
    this.qType = itm
    this.loadQuestions(this.page = 1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '题型',
      value: itm[1],
      paper_type: ''
    })
  }
  public clickQErrRate(itm) {
    this.qErrRate = itm
    this.loadQuestions(this.page = 1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '错误率',
      value: itm[1],
      paper_type: ''
    })
  }
  public onClickRanger(val) {
    this.sortType = val
    this.loadQuestions(this.page = 1)

    window['sensors'].track('TIKU_afterFilter_clk', {
      moduleName: this.moduleName,
      filter: val == 1 ? '综合排序' : '时间排序'
    })
  }
  // 点击高频错题的年级
  public clickGradeLevel(val) {
    this.gradeLevel = val
    this.loadQuestions(this.page = 1)
  }
  // 选择时间
  public selectTime(val) {
    this.selectedTime = val
    this.loadQuestions(this.page = 1)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '时间',
      value: val[1],
      paper_type: ''
    })
  }
  public onSearch(val) {
    this.loadQuestions(this.page = 1)
    window['sensors'].track('TIKU_search', {
      moduleName: this.moduleName,
      keyword: this.currentTitle
    })
  }
  public onFilterHasAnalysis(e) {
    this.hasAnalysis = e.target.checked
    this.loadQuestions(this.page = 1)
    if (this.hasAnalysis) {
      window['sensors'].track('TIKU_afterFilter_clk', {
        moduleName: this.moduleName,
        filter: '有解析'
      })
    }
  }
  // 题目操作
  @Watch('cartInfo', { deep: true })
  public onCartChange(val, old) {
    if (!this.unMounted) {
      this.onFlagChange(this.cartInfo, this.questions)
    }
  }
  // 全选
  public async chooseAll() {
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.moduleName,
      buttonName: '本页全选'
    })

    if (!this.userInfo || !this.userInfo.nickname) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    //
    let arr = [...this.cartInfo.question_ids]
    let temp: any = []
    let params: any = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subjectId,
      usage
    }
    for (let n of this.questions) {
      temp = [...temp, n.id]
    }
    params.question_cart.question_ids = [...new Set([...arr, ...temp])]
    let data: any = await updateQuestionCart(params)
    if (data.success) {
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.questions)
    } else {
      this.$message.warning(data.error)
    }
  }
  public onFlagChange(data, data2) {
    let dataCopy = JSON.parse(JSON.stringify(data2))

    for (let n of dataCopy) {
      if (!data) {
        return
      }
      if (data.question_ids.findIndex((item) => (n as any).id === item) > -1) {
        n.inShoppingCart = true
      } else {
        n.inShoppingCart = false
      }
      if (n.showAnalysis) {
        n.showAnalysis = true
      } else {
        n.showAnalysis = false
      }
      if (n.is_collected) {
        n.is_collected = true
      } else {
        n.is_collected = false
      }
    }
    this.questions = dataCopy
  }
  public async cartAdd(id: number | string) {
    let data: any = await addQuestionToCart({
      question_id: id,
      subject_id: this.subjectId,
      usage
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.questions)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }

    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.moduleName,
      buttonName: '加入组卷'
    })
  }
  public async cartDelete(id: number | string) {
    let data: any = await removeUestionFromCart({
      question_id: id,
      subject_id: this.subjectId,
      usage
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.questions)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.moduleName,
      buttonName: '移出组卷'
    })
  }
  public addToCart(data) {
    if (data.val) {
      this.cartAdd(data.id)
    } else {
      this.cartDelete(data.id)
    }
  }
  public openAnalysis(item) {
    item.showAnalysis = !item.showAnalysis
    
    window['sensors'].track('TIKU_otherFunction_clk', {
      moduleName: this.moduleName,
      functionName: item.showAnalysis ? '显示解析' : '收起解析'
    })
  }
  public reset() {
    window.location.reload()
  }
  public onPageChange(page) {
    this.loadQuestions(this.page = page)
    this.scrollTo(0) // 滚动到顶
  }
  // 获取题目列表
  // tslint:disable-next-line:cyclomatic-complexity
  public async loadQuestions(page, cata?) {
    this.loading = true
    let params: any = {}
    let errClassIds
    let errGrade
    let grade

    if (this.defaultTab.value == '1') {
      if (!(this.qClass && this.qClass.group_id)) return
      errClassIds = this.qClass.group_id
      errGrade = undefined
      this.sortType = 0
    } else if (this.defaultTab.value == '2') {
      if (!(this.qGrade.class_ids && this.qGrade.class_ids.length > 0)) return
      errClassIds = undefined
      errGrade = this.qGrade.level
      this.sortType = 0
    } else {
      if (!(this.gradeLevel && this.gradeLevel.length > 0)) return
      errClassIds = undefined
      errGrade = undefined
      // grade = this.gradeLevel && this.gradeLevel[0]
      grade = undefined
      this.sortType = 3
    }

    params = {
      is_ceping: 1,
      err_rate: String(this.qErrRate[0]), // 错误率
      err_class_id: errClassIds, // 班级
      err_grade: errGrade, // 年级
      grade,
      subject_id: this.subjectId,
      page,
      keyword: this.currentTitle,
      sort_type: Number(this.sortType),
      business_type: Number(this.qType[0]),
      book_catalog_id: '',
      knowledge_point_ids: [],
      kp_search_type: undefined,
      has_analysis: this.hasAnalysis ? 1 : 0, // 是否解析only
      time_interval: String(this.selectedTime[0]),
      main_question_type: this.questionClass && this.questionClass[0]
    }
    if (~~this.bookorkps === 2) {
      // params.book_catalog_id = ''
      if (~~this.singleormulti === 2) {
        params.knowledge_point_ids = this.processFactors(this.factors.checked)
        params.kp_search_type = ~~this.isUnion || 1
      } else {
        params.knowledge_point_ids = this.processFactors(this.kps)
      }
      // 知识点
      params.book_catalog_id = this.textbookVersion
      params.grade_term = this.grade
    } else {
      params.knowledge_point_ids = []
      // 章节
      params.grade_term = undefined
      if (this.catalog && !cata) {
        params.book_catalog_id = this.catalog
      } else {
        params.book_catalog_id = this.book
      }
      if (this.defaultTab.value === '1' || this.defaultTab.value === '2') {
        params.book_catalog_id = ''
      }
    }

    if (this.unMounted) return
    try {
      if (this.QuestionApiSource && this.QuestionApiSource.token) {
        this.QuestionApiSource.cancel()
        this.QuestionApiSource = null
        
      }

      let CancelToken = axios.CancelToken;
      this.QuestionApiSource = CancelToken.source();
      let cancelToken = this.QuestionApiSource.token;
      if (this.$route.path !=='/assessment/mistake') return
      let { data, success }: any = await questionList(params, cancelToken)
    
      if (success) {
        this.total = data.total_count
        this.sum = data.page_count * this.perPage
        this.onFlagChange(this.cartInfo, data.questions)
      } else {
        this.questions = []
        this.total = 0
        this.sum = 0
      }
    } catch (e) {
      this.questions = []
      this.total = 0
      this.sum = 0
    } finally {
      this.loading = false
    }
  }
}
